import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import styles from './WhistleblowerSystem.module.css';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import { IonRouterLink } from '@ionic/react';

const WhistleblowerSystem: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper name="whistleblower-system-page" showFooter className={styles.page}>
      <h1>{t('whistleblower_system.title')}</h1>

      <section>
        <p>{t('whistleblower_system.p1')}</p>
        <p>{t('whistleblower_system.p2')}</p>
        <p>
          <Trans i18nKey="whistleblower_system.p3">
            <IonRouterLink href="https://boersestuttgartgroup.integrityline.app/" />
          </Trans>
        </p>
      </section>
    </PageWrapper>
  );
};

export default withTranslation()(WhistleblowerSystem);
